import { render } from "./AddNFTDialog.vue?vue&type=template&id=3ccb7fc7&scoped=true"
import script from "./AddNFTDialog.vue?vue&type=script&lang=js"
export * from "./AddNFTDialog.vue?vue&type=script&lang=js"

import "./AddNFTDialog.vue?vue&type=style&index=0&id=3ccb7fc7&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccb7fc7"]])

export default __exports__